export default [
  {
    path: "apps/calendar",
    name: "calendar",
    navigationName: "Kalender",
    meta: { requiresAuth: true, layout: "Backend" },
    component: () => import("@/views/backend/apps/calendar/UserCalendar.vue"),
  },
];
